import { useEffect, useState } from 'react'

import {
  getRequestRecommendedContractors,
  updateRequestProfile,
} from '../../../../../../api'
import { EMPTY_LIST } from '../../../../../../constants/common'
import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../../constants/request'
import { useAsyncCallback, useNotification } from '../../../../../../hooks'
import { useRequestProfileContext } from '../../../../RequestProfile.hooks'
import { getRequestProfilePatchMergeData } from '../../../../RequestProfile.utils'
import {
  getPreparedRequestProfileWidgetRecommendedContractorsData,
  getRequestProfileWidgetProvidersInitialValues,
} from '../../RequestProfileWidgetProviders.utils'

export function useRequestProfileWidgetProvidersData({
  requestId,
  requestPermissions,
}) {
  const {
    handleMergeEntityData,
    handleReloadAfterChange,
    outboundUuid,
    requestContractors,
  } = useRequestProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const canViewRecommendedContractors = Boolean(
    requestPermissions?.can_view_recommended_contractors
  )

  const [recommendedProviders, setRecommendedProviders] = useState(EMPTY_LIST)

  const handleLoadRecommendedContractors = useAsyncCallback(() => {
    return getRequestRecommendedContractors({ id: requestId, outboundUuid })
      .then(response => {
        setRecommendedProviders(
          getPreparedRequestProfileWidgetRecommendedContractorsData(
            response?.data
          )
        )
      })
      .catch(() => {
        setRecommendedProviders(EMPTY_LIST)
      })
      .then(() => null)
  }, [outboundUuid, requestId])

  useEffect(() => {
    if (requestId && canViewRecommendedContractors) {
      handleLoadRecommendedContractors()
    }
  }, [requestId])

  async function handleReloadAfterUpdate() {
    return Promise.all([
      handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.providers),
      canViewRecommendedContractors ? handleLoadRecommendedContractors() : null,
    ])
  }

  async function handleSubmit({ payload }) {
    return updateRequestProfile({ data: payload, id: requestId, outboundUuid })
      .then(({ data }) => {
        handleAddSuccessNotification('Notification.CommonTitleSavedKey')
        handleMergeEntityData(getRequestProfilePatchMergeData(data))

        return handleReloadAfterUpdate()
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  const formInitialValues =
    getRequestProfileWidgetProvidersInitialValues(requestContractors)

  return {
    formInitialValues,
    handleSubmit,
    recommendedProviders,
  }
}
